import React, { useRef, useState, useEffect } from "react";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import GalleryButton from "./GalleryActionButton";
import { handleModalTriggerEvent } from "../../utils/handleModalTriggerEvent";
import { hasAssociatedLooks } from "../looks/utils/hasAssociatedLooks";
import { useLooksProducts } from "../../context/looks/LooksProductsContext";
import { LOOKS_POSITION } from "../../analytics/looks/looksModal";
import { LOOKS_OPEN_MODAL_EVENT } from "../looks/constants.js";
import { handleLooksScroll } from "../looks/utils/handleLooksScroll";
import { SMALL_VIEWPORT } from "../../constants";
import { useViewport } from "../../context/viewport/ViewportContext";

const LooksGalleryButton: React.FC = () => {
  const [shouldShowLooksButton, setShouldShowLooksButton] = useState(false);
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };
  const buttonText = getTranslation("pdp_associated_buy_the_look_title");
  const looksButtonRef = useRef<HTMLButtonElement>(null);
  const { looksProducts } = useLooksProducts() as { looksProducts: unknown };
  const { viewportCategory } = useViewport();

  const onSmallViewport = viewportCategory === SMALL_VIEWPORT;

  useEffect(() => {
    setShouldShowLooksButton(hasAssociatedLooks({ looksProducts }));
  }, [looksProducts]);

  if (!shouldShowLooksButton) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onSmallViewport) {
      handleModalTriggerEvent({
        focusOnCloseElement: looksButtonRef.current,
        position: LOOKS_POSITION.TOP,
        eventKey: LOOKS_OPEN_MODAL_EVENT,
        data: undefined,
      });
    } else {
      handleLooksScroll({ event, looksProducts });
    }
  };

  return (
    <GalleryButton
      ref={looksButtonRef}
      iconClass={"product-hanger"}
      ariaLabel={buttonText}
      buttonText={buttonText}
      handleClick={handleClick}
      dataTestId={"looksButtonHero"}
    />
  );
};

export default LooksGalleryButton;
